export const PROVIDERS_API = `/gateway/api/object-resolver/providers`;
